import { createContext } from "react"

export type PageTitleContextValue = {
  title: string | undefined
  setNewPageTitle: (newTitle: string | undefined) => void
}

export const PageTitleContext = createContext<PageTitleContextValue | null>(null)
